import React, { useEffect, useState } from "react";
import {notifyError, notifySuccess} from "../../helper";
import client from "../../api";
import BlockLoader from "../BlockLoader";
import EditLabelModelWindow from "./models/EditLabelModelWindow";
import DeleteLabelModelWindow from "./models/DeleteLabelModelWindow";

const FilterLabel = (props) => {
    
    const api = client();
    const { setAppliedLabels, appliedLabels, setUnLabeledState, unLabeledState, setRefreshFilters, refreshFilters } = props;
    const [refreshList,setRefreshList] = useState(false);
    const [allLabels, setAllLabels] = useState([]);
    const [fetchLoader, setFetchLoader] = useState(true);
    const [saveLoader, setSaveLoader] = useState(false);
    const [toggleAddLabelBox, setToggleAddLabelBox] = useState(false);
    const [toggleEditModelWindow, setToggleEditModelWindow] = useState(false);
    const [toggleDeleteModelWindow, setToggleDeleteModelWindow] = useState(false);
    const [newLabel, setNewLabel] = useState('');
    const [selectedLabel, setSelectedLabel] = useState('');
    const [error, setError] = useState('');
    const inputFieldChange = (e) => {
        setNewLabel(e.target.value);        
    }

    const closeAddLabelBox = () => {

        setNewLabel('');
        setError('');
        setToggleAddLabelBox(false);
    }

    const handleSaveLabel = async () => {
        if(newLabel === ''){
            setError('Label Name is required');
        } else if(is_duplicate(newLabel)){
            setError('Label already exists');
        } else {
            try{
                setSaveLoader(true);
                const payload = {
                    label_name:newLabel
                }
                const response = await api.post("/v1/label/create",payload);
                if(response.status === 200 || response.status === 201){
                    notifySuccess("New Label Saved successfully");
                    setNewLabel('');
                    setToggleAddLabelBox(false);
                    setRefreshList(!refreshList);
                    setRefreshFilters(!refreshFilters);
                }
            } catch(error){
                setSaveLoader(false);
                console.log("error.message",error);
                if(error.status === 400){
                    notifyError('Bad Request. Unable to save Label. Please try again.');
                }
            } finally {
                setSaveLoader(false);
            }
        }
    }

    const is_duplicate = (label) => {
        return allLabels.length ? allLabels.some(item => item.label_name.toLowerCase() === label.toLowerCase()) : false;        
    }

    const applyLabel = (labelId) => {
        setUnLabeledState(false);
        if(!appliedLabels.includes(labelId)){
            setAppliedLabels([labelId]);
        } else {
            setAppliedLabels([]);
        }
    }

    const appendLabelFilter = (labelId) => {
        setUnLabeledState(false);
        if(appliedLabels.includes(labelId)){
            setAppliedLabels((appliedLabels) => appliedLabels.filter(item => item !== labelId));
        } else {
            setAppliedLabels([...appliedLabels,labelId]);
        }
    }

    const applyUnLabeledFilter = () => {
        setAppliedLabels([]);
        setUnLabeledState(!unLabeledState);
    }

    const handleDeleteLabel = async (label) => {
        setSelectedLabel(label);
        setToggleDeleteModelWindow(true);

    }

    const handleEditLabel = async (label) => {
        setSelectedLabel(label);
        setToggleEditModelWindow(true);
    }

    const onBlur = () => {
        if(newLabel === ''){
            setError('Label Name is required');
        }
    }
    const onFocus = () => {
        setError('');
    }

    useEffect(()=>{
        const getAllLabels = async () => {
            try{
                setFetchLoader(true);
                const response = await api.post("/v1/label/list");
                if(response.status === 200 || response.status === 201){
                    const labels = response.data.labels;
                    setAllLabels(labels !== null ? labels : []);
                }
            } catch(error){
                setFetchLoader(false);
                console.log("error.message",error);
                if(error.status === 400){
                    notifyError('Bad Request. Unable to fetch Labels. Please try again.');
                }
            } finally {
                setFetchLoader(false);
            }
        }
        getAllLabels();
    },[refreshList]);

    return(<>
        <div className="search-label-filter-wrap">
            <div className="left-block">
                <div className="add-label">
                    {toggleAddLabelBox && <div className="create-label">
                        {error.length ? <span className="validation-error">{error}</span>:''}
                        <div className="field-outer">
                            <div className="input-group">
                                <input 
                                    type="text" 
                                    name="new-label" 
                                    value={newLabel}
                                    onChange={inputFieldChange}
                                    onBlur={onBlur}
                                    onFocus={onFocus}
                                    />
                                <button 
                                    className="close-btn" 
                                    type="button"
                                    onClick={()=>{closeAddLabelBox()}}
                                    ><i className='bx bx-x'></i></button>
                            </div>
                            <button 
                                type="button"
                                className={saveLoader ? "save-btn button--loading":"save-btn"} 
                                disabled={saveLoader}
                                onClick={()=>{handleSaveLabel()}}
                                ><span className="button--text"><i className='bx bx-check'></i></span></button>
                            
                        </div>
                        
                    </div>}
                    <div className={toggleAddLabelBox ? `new-label selected`:`new-label`} onClick={()=>{setToggleAddLabelBox(!toggleAddLabelBox); setError('')}}> <i className='bx bx-plus-circle'></i> Label</div>
                </div>         
                <div className="no-label">
                    <div className={ unLabeledState ? 'unlabeled selected' : 'unlabeled' } onClick={()=>{applyUnLabeledFilter()}}> <i className='minus-circle'></i> Unlabeled</div>
                </div>         
            </div>
            {fetchLoader ? <div className="right-block" style={{width: '100%', justifyContent: 'flex-start'}}><BlockLoader/></div> : <div className={appliedLabels.length ? `right-block label-enabled`:`right-block`}>
                {allLabels !== null && allLabels.map((label,i)=>(<div key={i} className="filter-label-wrap">
                    <div className={appliedLabels.includes(label._id) ? `filter-label selected`:`filter-label`}>
                        {appliedLabels.length ? <div className="label-checkbox">
                            <label className="checkbox-wrap" htmlFor={`filter-${i}`}>
                                <input 
                                    id={`filter-${i}`} 
                                    name="filter-checkbox"
                                    type="checkbox"
                                    checked = {appliedLabels.includes(label._id) }
                                    onChange={()=>{appendLabelFilter(label._id)}}
                                    />
                            </label>
                        </div>:''}
                        <button 
                            className="filter-item"
                            onClick={()=>{applyLabel(label._id)}}
                            >
                                <i className={ appliedLabels.length ? `bx bx-purchase-tag hide-me`:` bx bx-purchase-tag`}></i> 
                                {label.label_name}
                        </button>
                        <span className="sub-items">
                            <i className='bx bx-dots-vertical-rounded'></i>
                            <div className="action-items-wrap">
                                <div className="action-items-inner">
                                    <button
                                        type="button" 
                                        className="edit-btn"
                                        onClick={()=>{handleEditLabel(label)}}>
                                    <i className='bx bx-edit-alt' ></i> Edit
                                    </button>
                                    <button 
                                        type="button"
                                        className="delete-btn"
                                        onClick={()=>{handleDeleteLabel(label)}}>
                                        <i className='bx bx-trash'></i> Delete
                                    </button>    
                                </div>
                            </div>
                        </span>
                        </div>
                </div> ))}                                
            </div>}
        </div>
        {toggleEditModelWindow ? <EditLabelModelWindow 
            toggleEditModelWindow = {toggleEditModelWindow}
            setToggleEditModelWindow = { setToggleEditModelWindow }
            selectedLabel = { selectedLabel }
            />:''}

        {toggleDeleteModelWindow ? <DeleteLabelModelWindow 
            toggleDeleteModelWindow = {toggleDeleteModelWindow}
            setToggleDeleteModelWindow = { setToggleDeleteModelWindow }
            selectedLabel = { selectedLabel }
            />:''}
    </>);
}

export default FilterLabel;